import { styled } from 'linaria/react';

export const Block = styled.div`
	width: 100%;
	max-width: var(--layout-width);
	margin: 0 32px;
	padding: 24px;
	background: white;
	border-radius: 0px;
`;
